import React, { useContext, useEffect } from "react";
import { loadUser } from "redux-oidc";

import { useSelector } from "react-redux";
import { AuthStep, selectAuthStep } from "../../store/auth/auth.reducer";
import { CircularProgress, Grid, Paper } from "@mui/material";
import { getInitialUserAndAppInfos } from "../../store/auth/auth.action";
import { userManager } from "../../../core/services/user.manager.service";
import store, { StoreState, useAppDispatch } from "../../store";
import { IsFramedCtx } from "../../../index";
import {UtilsService} from "../../../core/services/utils.service";

/**
 * Composant transitoire permettant de restaurer la session utilisateur après rechargement de la page
 * (si un access-token valide existe dans le navigateur) ou de rediriger l'utilisateur vers le portail
 * pour s'authentifier.
 */
const LoginPage = () => {
	const dispatch = useAppDispatch();
	const authStep = useSelector((state: StoreState) => selectAuthStep(state.auth));
	const authPending = authStep === AuthStep.RetrieveUserInfos;

	useEffect(() => {
		console.log("Login page, auth-step : " + authStep);
		if (authPending)
			//Processus déjà en cours, on ne fait rien.
			return;
		const loadUserAndFetchInfos = async () => {
			const user = await userManager.getUser();
			if (user && !user.expired) {
				//Si c'est possible, on restaure la session depuis les infos stockée dans le navigateur par la bibliothèque 'oidc-client'.
				console.log("Restoring user session");
				const loadedUser = await loadUser(store, userManager);
				dispatch(getInitialUserAndAppInfos(loadedUser.profile.sub));
			} else {
				console.log("Requiring sign-in")
				const fullPath = UtilsService.getAuthRedirectPath();
				userManager.signinRedirect({ state: fullPath });			}
		};
		loadUserAndFetchInfos();
	}, [authStep, authPending, dispatch]);

	const isFramed = useContext(IsFramedCtx);

	return (
		<Paper className={"LoginPage"} sx={{ height: "100%" }}>
			<Grid container justifyContent={"center"} alignContent="center" height={"100%"}>
				{isFramed ? (
					<CircularProgress />
				) : (
					<Grid item>
						<h3>{authStep === AuthStep.Starting ? "Démarrage de l'authentification" : "Authentification en cours ..."}</h3>
					</Grid>
				)}
			</Grid>
		</Paper>
	);
};

export default LoginPage;
